import React, { useEffect, useState } from 'react'
import { postPasaAlEstadoConfirmado, postProcedimientosQxPaciente, postUltimoConsecutivoAmbulatorio } from '../services/PaginaRuta'
// import TablaSeleccionServicio from './TablaSeleccionServicio'
import TablaSeleccionServicioAmbulatorio from './TablaSeleccionServicioAmbulatorio'
import Loading from './Loading'
import ModalMensajeNoTieneIngreso from './ModalMensajeNoTieneIngreso'

const ModalSeleccionServicio = ({setmodalOnSeleccionServicio,user,passChildCambioDeEstado,setmodalOnConfirmar}) => {
 
  const [procedimientosNoTinenenMedico, setprocedimientosNoTienenMedico]=useState([])
  const [dataAmbulatorio,setdataAmbulatorio]=useState([])
  const [validarQueTenganProcedimientos, setvalidarQueTenganProcedimientos]=useState(true)
  const [modalOnNoTieneConsecutivo, setmodalOnNoTieneConsecutivo]=useState(false)
  const [loading, setLoading]=useState(false)
    const handleCancelarClick=()=>{
        setmodalOnSeleccionServicio(false)
    }

    useEffect(()=>{
      // const body={
      //   varTFCedu:user.MPCedu,
      //   varClaPro:'2',
      //   varTFTDoc:user.MPTDoc
      // }
     
      // postPasaAlEstadoConfirmado(body).then((res)=>{
      //   //console.log(res.data,'dataaa jessica')
      //   setdataInfo(res.data[0])
      //   setdataTable(res.data)        
        
      // })
      
      const ambulatorio={
        TFCedu:user.MPCedu,
        TFTDoc:user.MPTDoc,
      }
      setLoading(false)
      postUltimoConsecutivoAmbulatorio(ambulatorio).then((res)=>{
        setLoading(true)
        console.log(res.data.length,'data ambulatorio')
        if(res.data.length === 0){
          setmodalOnNoTieneConsecutivo(true)
        }
        setdataAmbulatorio(res.data)
      })
    },[])

    useEffect(()=>{
      const body={
        ProCirCod: user.ProCirCod,
      }
      postProcedimientosQxPaciente(body).then((res)=>{
        
        const datosProcedimientos = res.data;      
        
        if(datosProcedimientos.length > 0){
          setvalidarQueTenganProcedimientos(true)
        }else{
          setvalidarQueTenganProcedimientos(false)
        }
        // Filtrar los elementos que no tienen un valor válido en MedCod
        const invalidos = datosProcedimientos.filter(item => item.MedCod === null || item.MedCod.trim() === '');
        console.log(invalidos,' invalidos'); // false, porque no todos los elementos tienen un valor válido en MedCod
        setprocedimientosNoTienenMedico(invalidos)

      })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Selección del Servicio*
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="px-8 pt-3">
            <h5
              className="text-lg font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            >
              PACIENTE
            </h5>
          </div>
          <div className="flex-auto overflow-y-auto relative p-2">
            <div className="flex py-2 text-left">
              <div className="w-1/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                  Tipo Documento
                </label>
                <input
                  defaultValue={user.MPTDoc}
                  disabled={true}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Numero de cédula
                </label>
                <input
                  defaultValue={user.MPCedu}
                  disabled={true}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              <div className="w-2/5  px-1 ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Nombre
                </label>
                <input
                  disabled={true}
                  defaultValue={user.MPNOMC}
                  type="text"
                  className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                  id="exampleFormControlInput1"
                  placeholder=""
                />
              </div>
              
            </div>
            
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Ctvo. Ingreso
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Fecha de Ingreso
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-4"
                          >
                            Servicio
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* {
                          dataTable.map((item,index)=>(
                            <TablaSeleccionServicio key={index} item={item} user={user} setmodalOnSeleccionServicio={setmodalOnSeleccionServicio} passChildCambioDeEstado={passChildCambioDeEstado} setmodalOnConfirmar={setmodalOnConfirmar}/>
                          ))
                        } */}
                        {
                          loading?
                          dataAmbulatorio.map((item,index)=>(
                            <TablaSeleccionServicioAmbulatorio key={index} item={item} user={user} setmodalOnSeleccionServicio={setmodalOnSeleccionServicio} passChildCambioDeEstado={passChildCambioDeEstado} setmodalOnConfirmar={setmodalOnConfirmar}  procedimientosNoTinenenMedico={procedimientosNoTinenenMedico} validarQueTenganProcedimientos={validarQueTenganProcedimientos}/>
                          ))
                          :
                          <tr>
                            <td></td>
                            <td><Loading/></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-1 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            {/* <button type="button"
            className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Confirmar
          </button> */}
          </div>
        </div>
      </div>
      {modalOnNoTieneConsecutivo && <ModalMensajeNoTieneIngreso setmodalOnNoTieneConsecutivo={setmodalOnNoTieneConsecutivo} />}
    </div>
  )
}

export default ModalSeleccionServicio